<app-toast-messages />
<div class="app-container">
  @if (!isApaApp()) {
    <app-navbar class="width-100" />
  }
  @if (isApaApp() && !isApaAppV3()) {
    <div class="apa-app-padding"></div>
  }
  <div class="router-container">
    <router-outlet></router-outlet>
  </div>
</div>
